module.exports = __webpack_public_path__ + "media/images/emblems/Lutry-coat_of_arms-fd62de2be9650f6b05c986eee174be72.svg";